import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './Pay.css'
import Text from '../../../components/text/Text'
import yellowWarning from '../../../assets/icons/icons-yellow-warning.png'
import 'react-datepicker/dist/react-datepicker.css'
import PaymentCard from './../../../components/payCard/PaymentCard'
import {
    getUninvoicedMovements,
    requestProforma,
} from '../../../services/billing'
import { currencyFormat } from '../../../formatters'
import routes from '../../../router/routes'
import ModalComponent from '../../../components/modal/ModalComponent'
import { labels } from '../../../labels'
import ReactDatePicker from 'react-datepicker'

const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)

interface IUninvoicedTransactionsData {
    transactionCount: string
    monto?: string
}

type RequestType = 'Pronto Pago' | 'Pago Normal'

interface IUser {
    establishment: string
}

export default function Pay() {
    const navigate = useNavigate()
    const [uninvoicedTransactionsData, setUninvoicedTransactionsData] =
        useState<IUninvoicedTransactionsData | null>(null)
    const [uninvoicedTransactionsDataAyer, setUninvoicedTransactionsDataAyer] =
        useState<IUninvoicedTransactionsData | null>(null)

    const [startDateEarlyPayment, setStartDateEarlyPayment] =
        useState<Date | null>(new Date())
    const datePickerRefEarlyPayment = useRef<ReactDatePicker | null>(null)
    const [
        consumptionUntilDateEarlyPayment,
        setConsumptionUntilDateEarlyPayment,
    ] = useState<string>('')

    const [startDateNormalPayment, setStartDateNormalPayment] =
        useState<Date | null>(new Date())
    const datePickerRefNormalPayment = useRef<ReactDatePicker | null>(null)
    const [
        consumptionUntilDateNormalPayment,
        setConsumptionUntilDateNormalPayment,
    ] = useState<string>('')

    const [showModal, setShowModal] = useState<boolean>(false)
    const [modalContent, setModalContent] = useState<React.ReactNode>('')
    const [requestType, setRequestType] = useState<RequestType | undefined>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)

    const currentUser = localStorage.getItem('currentUser')
    const user: IUser | null = currentUser ? JSON.parse(currentUser) : null
    const establishment = user?.establishment

    useEffect(() => {
        getMovementsInfo()
        setTodayDate()
    }, [])

    const getMovementsInfo = async () => {
        try {
            const resp = await getUninvoicedMovements(establishment ?? '')
            const currentDataTmp = resp.body.data.totales
            const yesterdayDataTmp = resp.body.data.totalesAyer
            setUninvoicedTransactionsData(yesterdayDataTmp)
            setUninvoicedTransactionsDataAyer(yesterdayDataTmp)
        } catch (err) {
            console.error('Error al cargar movimientos sin facturar:', err)
        }
    }

    const setTodayDate = () => {
        const today = new Date()
        today.setDate(yesterday.getDate())
        today.setHours(23, 59, 0, 0)

        const formattedDate = formatDateTime(today)
        setConsumptionUntilDateEarlyPayment(formattedDate)
        setConsumptionUntilDateNormalPayment(formattedDate)
    }

    const formatDateTime = (date: Date) => {
        return `${date.getDate().toString().padStart(2, '0')}-${(
            date.getMonth() + 1
        )
            .toString()
            .padStart(2, '0')}-${date.getFullYear()} a las 23:59hrs.`
    }

    const openModal = (type: RequestType) => {
        const selectedDate =
            type === 'Pronto Pago'
                ? consumptionUntilDateEarlyPayment
                : consumptionUntilDateNormalPayment
        setRequestType(type)
        setModalContent(
            <>
                ¿Está seguro que desea solicitar la proforma{' '}
                <strong>{type}</strong> con la fecha seleccionada <br />
                <strong>{selectedDate}</strong>?
            </>
        )
        setShowModal(true)
        setIsSuccess(false)
    }

    const handleProformaRequest = () => {
        if (!requestType) return

        const selectedDate =
            requestType === 'Pronto Pago'
                ? consumptionUntilDateEarlyPayment
                : consumptionUntilDateNormalPayment

        const onlyDate = selectedDate.split(' ')[0]
        const [_day, _month, _year] = onlyDate.split('-').map(Number)
        const newDate = new Date(Date.UTC(_year, _month - 1, _day, 0))
        newDate.setDate(newDate.getDate() + 1)
        const getNewDate = newDate.toISOString().split('T')[0]
        const [year, month, day] = getNewDate.split('-').map(Number)

        setIsLoading(true)
        requestProforma(
            `${day.toString().padStart(2, '0')}-${month
                .toString()
                .padStart(2, '0')}-${year}`,
            requestType === 'Pronto Pago'
        )
            .then((res) => {
                if (res.body.statusCode === 200) {
                    setIsSuccess(true)
                } else {
                    alert('Los movimientos no pudieron ser proformados.')
                }
            })
            .catch((error) => {
                console.error('Error al solicitar proforma:', error)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const navigateToBillingHistory = () => {
        navigate(`/${routes.billing}/${routes.billingMain}`)
    }

    const handleDateChange = (date: Date | null, tipo: RequestType) => {
        if (date) {
            date.setHours(23, 59, 0, 0)
            const formattedDate = formatDateTime(date)
            if (tipo === 'Pronto Pago') {
                setConsumptionUntilDateEarlyPayment(formattedDate)
                setStartDateEarlyPayment(date)
            } else {
                setConsumptionUntilDateNormalPayment(formattedDate)
                setStartDateNormalPayment(date)
            }
        }
    }

    const renderModalConfirmationContent = () => {
        if (isLoading) {
            return <div className="loader">Solicitando proforma...</div>
        }

        if (isSuccess) {
            return (
                <>
                    <Text
                        label={labels.proformaRequested}
                        fontSize={14}
                        fontWeight={400}
                        color="#656565"
                        marginBottom={25}
                    />
                    <button
                        onClick={navigateToBillingHistory}
                        className="uninvoiced-btnSolicitar"
                    >
                        <Text
                            label={labels.goToBilling}
                            fontWeight={600}
                            color="#ffffff"
                        />
                    </button>
                </>
            )
        }

        return (
            <>
                <div
                    style={{
                        padding: '20px',
                        color: '#656565',
                        fontSize: '14px',
                        fontWeight: 400,
                    }}
                >
                    {modalContent}
                </div>
                <button
                    onClick={handleProformaRequest}
                    className="uninvoiced-btnSolicitar"
                >
                    <Text
                        label={labels.requestProforma}
                        fontWeight={600}
                        color="#ffffff"
                    />
                </button>
            </>
        )
    }

    return (
        <>
            {/* Modal de confirmación */}
            <ModalComponent
                show={showModal}
                handleClose={() => setShowModal(false)}
                title={isSuccess ? 'Solicitud Exitosa' : 'Confirmación'}
                modalStyle="uninvoiced-modalConfirmRequest"
                icon={!isLoading && !isSuccess}
            >
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    {renderModalConfirmationContent()}
                </div>
            </ModalComponent>

            {/* Sección de información de pagos */}
            <div className="uninvoiced-promotionCard">
                <div className="uninvoiced-flexDirectionPayment">
                    <img
                        src={yellowWarning}
                        style={{ width: 46, height: 46, marginRight: 20 }}
                    />
                    <div>
                        <Text
                            label={labels.warningPayment}
                            fontSize={16}
                            fontWeight={700}
                            color={'white'}
                        />
                        <Text
                            label={labels.prontoNormal}
                            fontSize={14}
                            fontWeight={400}
                            color={'white'}
                        />
                    </div>
                </div>
            </div>

            {/* Contenedor de las tarjetas de pago */}
            <div className="uninvoiced-container">
                <PaymentCard
                    title={labels.prontoPayment}
                    description={labels.prontoPagoDescription}
                    additionalInfo={labels.prontoPagoAdditionalInfo}
                    amount={currencyFormat(
                        parseFloat(uninvoicedTransactionsDataAyer?.monto || '0')
                    )}
                    dateLabel={consumptionUntilDateEarlyPayment}
                    selectedDate={startDateEarlyPayment}
                    onDateChange={(date) =>
                        handleDateChange(date, 'Pronto Pago')
                    }
                    openDatePicker={() =>
                        datePickerRefEarlyPayment.current?.setOpen(true)
                    }
                    openModal={() => openModal('Pronto Pago')}
                    datePickerRef={datePickerRefEarlyPayment}
                    maxDate={yesterday}
                />

                <PaymentCard
                    title={labels.normalPayment}
                    description={labels.normalPaymentDescription}
                    additionalInfo={labels.normalPaymentAdditionalInfo}
                    amount={currencyFormat(
                        parseFloat(uninvoicedTransactionsData?.monto || '0')
                    )}
                    dateLabel={consumptionUntilDateNormalPayment}
                    selectedDate={startDateNormalPayment}
                    onDateChange={(date) =>
                        handleDateChange(date, 'Pago Normal')
                    }
                    openDatePicker={() =>
                        datePickerRefNormalPayment.current?.setOpen(true)
                    }
                    openModal={() => openModal('Pago Normal')}
                    datePickerRef={datePickerRefNormalPayment}
                    maxDate={yesterday}
                />
            </div>
        </>
    )
}
